import { useState } from 'react';
import { BrowserRouter } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastProvider } from '@mgdlead/ui';

import { AvisoDeAtualizacao } from './components/AvisoDeAtualizacao';
import { AppRoutes } from './routes';
import { TRPCProvider, createApiClient, createQueryClient } from './lib/api';

/**
 * Providers do app.
 *
 * `useState(() => ...)` e não `const client = new ...` no módulo: um cliente
 * criado no escopo do módulo sobrevive ao hot reload e ao teste, e vaza cache
 * de uma sessão para a seguinte.
 */
export function App() {
  const [queryClient] = useState(createQueryClient);
  const [trpcClient] = useState(createApiClient);

  return (
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        <ToastProvider>
          <BrowserRouter>
            <AppRoutes />
            {/*
              Fora das rotas de propósito: o aviso vale em qualquer tela, inclusive na vitrine
              pública e no login. Dentro de uma rota, ele sumiria justamente quando a pessoa
              navegasse — que é quando o pedaço de código faltando aparece.
            */}
            <AvisoDeAtualizacao />
          </BrowserRouter>
        </ToastProvider>
      </TRPCProvider>
    </QueryClientProvider>
  );
}
